import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CustomerSupportMenu from "./menu/customer-supoort-menu";
import ActionDelete from "components/buttons/actionDelete";
import SaveButton from "components/buttons/save";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import Swal from 'sweetalert2'
import SafeField from "helpers/SafeField";
class helpfulLinks extends Component {
    constructor(props) {
        super(props)
        this.state = {
             helpCategories: [],
             links: []
        }

    }
      fetchCategory() {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
        const params = {
          agentId: localStorage.getItem("userId"),
        };
        axios
          .get(`${API_URL}HelpCategory/allforagent`, { headers, params })
          .then((response) => {
            this.setState({ helpCategories: response.data, loading: false });
          })
          .catch((error) => {
            this.setState({ error: error.message, loading: false });
          });
      }
      fetchLinks() {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
        const params = {
          agentId: localStorage.getItem("userId"),
        };
        axios
          .get(`${API_URL}AgentHelpfulLink/allAgent`, { headers, params })
          .then((response) => {
            this.setState({ links: response.data, loading: false });
          })
          .catch((error) => {
            this.setState({ error: error.message, loading: false });
          });
      }
      componentDidMount() {
        this.fetchCategory();
        this.fetchLinks();
      }
    
      handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
          const payload = {
            agentId: parseInt(localStorage.getItem('userId')),
            helpfulLinkTitle: values.helpfulLinkTitle,
            helpfulLinkCategory: parseInt(values.helpfulLinkCategory),
            helpfulLinkUrl: values.helpfulLinkUrl,
            isActive: true
          }
          toast.loading('Please wait...')
          const obj = JSON.parse(localStorage.getItem("authUser"));
          const token = obj?.resultData?.bearerToken;
          const response = await axios.post(
            `${API_URL}AgentHelpfulLink`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
    
          if (response.data.success) {
            toast.dismiss();
            toast.success('Saved successfully.')
            this.fetchLinks();
            resetForm();
          } else {
            toast.dismiss();
            toast.warn(response.data.validationErrors[0] || 'some issue please try after some time')
          }
        } catch (error) {
          console.error("Error submitting form:", error);
        } finally {
          setSubmitting(false);
        }
      };
      handleDelete = (id) => {
        Swal.fire({
          title: "Are you sure?",
          text: "You won’t be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        }).then((result) => {
          if (result.isConfirmed) {
            const obj = JSON.parse(localStorage.getItem("authUser"));
            const token = obj?.resultData?.bearerToken;
    
            axios
              .delete(`${API_URL}AgentHelpfulLink/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
              })
              .then(() => {
                Swal.fire("Deleted!", "Deleted successfully", "success");
                this.setState((prevState) => ({
                  links: prevState.links.filter((s) => s.id !== id),
                }));
              })
              .catch(() => {
                Swal.fire("Error!", "Something went wrong.", "error");
              });
          }
        });
      };
    render() {
      const { helpCategories, links } = this.state;
        return (
            <React.Fragment>
              <ToastContainer autoClose={2000} />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Setting")}
                                    breadcrumbItem={this.props.t("Customer Support")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <CustomerSupportMenu />
                                   <Formik
                                                  enableReinitialize={true}
                                                  initialValues={{
                                                    helpfulLinkTitle: "",
                                                    helpfulLinkCategory:"",
                                                    helpfulLinkUrl: "",
                                                   
                                
                                                  }}
                                                  validationSchema={Yup.object().shape({
                                                    helpfulLinkTitle: Yup.string().max(50, "Title must not exceed 50").required("This is Required"),
                                                    helpfulLinkCategory: Yup.string().required("This is Required"),
                                                    helpfulLinkUrl: Yup.string().url("Must be a valid URL").required("This is Required"),
                                      
                                                  })}
                                
                                                  onSubmit={this.handleSubmit}
                                                >
                                                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                                                    <Form
                                                      className="needs-validation"
                                                    >
                                              <Card className=""> 
                                                    <CardBody>
                                                    <div className="mt-0 card-title pheading">Add New</div>
                                              
                                                   <Row>
                                                    <Col sm="1">
                                                        <FormGroup className="mb-3">
                                                        <Label htmlFor="helpfulLinkCategory">
                                                          {this.props.t("Type *")}
                                                        </Label>
                                                        <SafeField
                                                          as="select"
                                                          name="helpfulLinkCategory"
                                                          className={
                                                            "form-control" +
                                                            (errors.helpfulLinkCategory &&
                                                              touched.helpfulLinkCategory
                                                              ? " is-invalid"
                                                              : "")
                                                          }
                                                          onChange={handleChange}
                                                        >
                                                          <option value="">Select</option>
                                                          {helpCategories.map((ind, index) => (
                                                            <option key={index} value={ind.id}>
                                                              {ind.helpCategoryTitle}
                                                            </option>
                                                          ))}
                                                        </SafeField>
                                                        <ErrorMessage
                                                          name="helpfulLinkCategory"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </FormGroup>
                                                        </Col>
                                              
                                                    <Col sm="4">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="helpfulLinkTitle">
                                                              {this.props.t("Name*")}
                                                            </Label>
                                                            <SafeField
                                                              name="helpfulLinkTitle"
                                                              onChange={handleChange}                            
                                                              type="text"
                                                              
                                                              className={
                                                                "form-control" +
                                                                (errors.helpfulLinkTitle && touched.helpfulLinkTitle
                                                                  ? " is-invalid"
                                                                  : "")
                                                              }
                                                             
                                                              id="helpfulLinkTitle"
                                                            />
                                                             <ErrorMessage
                                                              name="helpfulLinkTitle"
                                                              component="div"
                                                              className="invalid-feedback"
                                                            />
                                                          </FormGroup>
                                                        </Col>
                                                       
                                                   
                                                        <Col sm="3">
                                                          <FormGroup className="mb-3">
                                                            <Label htmlFor="helpfulLinkUrl">{this.props.t("Url *")}</Label>
                                                            <SafeField
                                                              name="helpfulLinkUrl"
                                                              onChange={handleChange}
                                                              type="text"
                                                              className={
                                                                "form-control" +
                                                                (errors.helpfulLinkUrl && touched.helpfulLinkUrl
                                                                  ? " is-invalid"
                                                                  : "")
                                                              }
                                                              id="helpfulLinkUrl"
                                                            />
                                                             <ErrorMessage
                                                              name="helpfulLinkUrl"
                                                              component="div"
                                                              className="invalid-feedback"
                                                            />
                                                          </FormGroup>
                                                        </Col>
                                                     
                                                        
                                                       
                                
                                                  
                                                       
                                                        <Col sm="2">
                                                        <div className="clearfix" style={{ marginTop: "30px" }}>
                                                          <SaveButton iconClass="">Submit</SaveButton>
                                                         </div>
                                                        </Col>
                                                    </Row>
                                
                                                
                                             
                                             </CardBody>
                                                </Card>
                                                	 <Card className=""> 
                    <CardBody>
                    <h5 className="card-title">History</h5>
					<div className="table-responsive">
          <table className="table">
              <thead className="">
							  <tr>
								
								<th>Type  </th>
								<th>Name</th>
								<th>URL</th>
								<th></th>
               
							  </tr>
							</thead>
                                <tbody>
                                      {links.map((link, index) => (
                                    <tr key={index}>
                                        <td>{helpCategories.find(opt => opt.id === link.helpfulLinkCategory)?.helpCategoryTitle || ""}</td>
                                        <td>{link.helpfulLinkTitle}</td>
                                        <td>
                                          <a href={link.helpfulLinkUrl} target="_blank" rel="noreferrer"> View</a>
                                        </td>
                                        <td>
                                            <ActionDelete onClick={() => this.handleDelete(link.id)}  />
                                        </td>
                                    </tr>
                                      ))}
                                </tbody>                      
						  </table>
						</div>
					</CardBody>
					</Card>
                                            </Form>
                                                  )}
                                                    </Formik>




                            </Col>

                        </Row>

                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
helpfulLinks.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,


}
const mapStateToProps = () => (
    {



    })
const mapDispatchToProps = dispatch => ({


});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(helpfulLinks))
